<template>
  <section class="comm-page dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right">
      <CommFilterBar :buttonList="buttonList" :searchList="searchList" @callFunction="callFunction" />
      <div class="comm-panel">
        <div class="tbl-scroll-host">
          <el-table
            ref="rulesTable"
            class="comm-table"
            empty-text="暂无数据"
            :row-key="rulesTableRowKey"
            :data="rules"
            v-loading="loading"
            height="100%"
            @selection-change="handleSelectionChange"
            @row-click="onRulesTableRowClick"
            style="width:100%">
            <el-table-column type="selection" width="44" />
            <el-table-column prop="Id" label="规则ID" width="150" show-overflow-tooltip />
            <el-table-column prop="RuleName" label="规则名称" min-width="120" show-overflow-tooltip />
            <el-table-column label="售价" width="88" align="right">
              <template slot-scope="scope">{{ formatPriceYuan(scope.row.PriceFen != null ? scope.row.PriceFen : scope.row.priceFen) }}</template>
            </el-table-column>
            <el-table-column prop="PkgType" label="套餐类型" width="100">
              <template slot-scope="scope">{{ scope.row.PkgType === 1 ? '按月套餐' : '一次性套餐' }}</template>
            </el-table-column>
            <el-table-column prop="Priority" label="优先级" width="72" align="center" />
            <el-table-column prop="IsEnabled" label="状态" width="80" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" :type="scope.row.IsEnabled ? 'success' : 'info'">
                  {{ scope.row.IsEnabled ? '启用' : '停用' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="Remark" min-width="100" label="备注" show-overflow-tooltip />
            <el-table-column label="操作" width="200" align="center" fixed="right">
              <template slot-scope="scope">
                <div class="table-op-pair">
                  <el-button type="text" size="small" @click.stop="openEdit(scope.row)">编辑</el-button>
                  <el-button type="text" size="small" @click.stop="openRuleUsers(scope.row)">套餐用户</el-button>
                  <el-button
                    type="text"
                    size="small"
                    :class="{ 'table-op-link--danger': scope.row.IsEnabled }"
                    @click.stop="setEnabled(scope.row, !scope.row.IsEnabled)"
                  >{{ scope.row.IsEnabled ? '停用' : '启用' }}</el-button>
                  <el-button type="text" size="small" class="table-op-link--danger" @click.stop="removeRule(scope.row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="comm-pager">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            :current-page="page"
            :page-size="pageSize"
            :total="total"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>

      <el-dialog
        :title="editForm.Id ? '编辑规则' : '新增规则'"
        :visible.sync="dialogVisible"
        width="680px"
        custom-class="rule-edit-dialog"
        :close-on-click-modal="false">
        <el-form :model="editForm" label-width="96px" class="rule-edit-form" size="small">
          <el-form-item label="规则名称">
            <el-input v-model="editForm.RuleName" placeholder="请输入规则名称" maxlength="50" show-word-limit clearable />
          </el-form-item>

          <el-form-item label="套餐类型">
            <el-radio-group v-model="editForm.PkgType" class="rule-type-group">
              <el-radio-button :label="1">按月套餐</el-radio-button>
              <el-radio-button :label="2">一次性套餐</el-radio-button>
            </el-radio-group>
          </el-form-item>

          <div class="rule-edit-row">
            <el-form-item label="优先级" class="rule-edit-row__item">
              <el-input-number v-model="editForm.Priority" :min="1" controls-position="right" class="rule-num" />
            </el-form-item>
            <el-form-item label="售价(元)" class="rule-edit-row__item">
              <el-input-number v-model="editForm.PriceYuan" :min="0.01" :precision="2" :step="1" controls-position="right" class="rule-num" />
            </el-form-item>
          </div>
          <div class="rule-edit-tip">数值越小越优先扣减；相同优先级按到期更早的先扣</div>

          <div v-if="editForm.PkgType === 1" class="rule-edit-row">
            <el-form-item label="套餐月数" class="rule-edit-row__item">
              <el-input-number v-model="editForm.MonthCount" :min="1" controls-position="right" class="rule-num" />
            </el-form-item>
            <el-form-item label="每月分钟" class="rule-edit-row__item">
              <el-input-number v-model="editForm.MonthCallDuration" :min="1" controls-position="right" class="rule-num" />
            </el-form-item>
          </div>
          <div v-else class="rule-edit-row">
            <el-form-item label="总分钟数" class="rule-edit-row__item">
              <el-input-number v-model="editForm.TotalMinutes" :min="1" controls-position="right" class="rule-num" />
            </el-form-item>
            <el-form-item label="有效天数" class="rule-edit-row__item">
              <el-input-number v-model="editForm.ValidDays" :min="1" controls-position="right" class="rule-num" />
            </el-form-item>
          </div>

          <el-form-item label="启用">
            <el-switch v-model="editForm.IsEnabled" active-text="启用" inactive-text="停用" />
          </el-form-item>
          <el-form-item label="备注">
            <el-input type="textarea" v-model="editForm.Remark" :rows="2" placeholder="选填" maxlength="200" show-word-limit />
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="saveRule">保存</el-button>
        </div>
      </el-dialog>

      <el-dialog  :title="`用户套餐记录 - ${ruleUserDialog.ruleName || ''}`" :visible.sync="ruleUserDialog.visible"
        width="1000px" :close-on-click-modal="false">
        <div class="toolbar-filter-bar toolbar-filter-bar--embed">
          <el-form :inline="true" class="toolbar-filter-form" @submit.native.prevent="ruleUserPage = 1; loadRuleUserRows()">
            <div class="toolbar-filter-fields">
              <el-form-item>
                <el-input v-model="ruleUserFilters.studentName" placeholder="学生姓名" clearable class="toolbar-field-w-md" />
              </el-form-item>
              <el-form-item>
                <el-button type="primary" size="small" icon="el-icon-search" @click="ruleUserPage = 1; loadRuleUserRows()">查询</el-button>
              </el-form-item>
            </div>
            <div class="toolbar-filter-actions">
              <el-button type="success" size="small" icon="el-icon-plus" @click="bindDialogVisible = true">绑定用户</el-button>
            </div>
          </el-form>
        </div>
        <el-table :data="ruleUserRows" v-loading="ruleUserLoading">
          <el-table-column prop="StudentName" label="学生姓名" />
          <el-table-column prop="StudentNo" label="学号" />
          <el-table-column label="有效期" min-width="168">
            <template slot-scope="scope">
              <div class="comm-cell-stack">
                <div><span class="comm-cell-muted">起</span>{{ scope.row.StartTime || scope.row.startTime || '—' }}</div>
                <div :class="{ 'expired-text': isBindingExpired(scope.row) }">
                  <span class="comm-cell-muted">止</span>{{ scope.row.ExpireTime || scope.row.expireTime || '—' }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <el-tag size="small" :type="getBindingStatusTagType(scope.row)">
                {{ formatBindingStatus(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="openQuotaDetail(scope.row)">套餐明细</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="record-page">
          <el-pagination layout="total, prev, pager, next, jumper" :page-size="ruleUserPageSize" :total="ruleUserTotal"
            @current-change="handleRuleUserPageChange" />
        </div>
      </el-dialog>

      <el-dialog :title="`绑定用户 - ${ruleUserDialog.ruleName || ''}`" :visible.sync="bindDialogVisible" width="780px"
        :close-on-click-modal="false" @open="onBindDialogOpen">
        <el-form label-width="90px">
          <el-form-item label="选择人员" required>
            <div class="ps-pick-summary">
              <span v-if="personSelectedItems.length">已选 <strong>{{ personSelectedItems.length }}</strong> 人</span>
              <span v-else class="muted-text">请从家校通讯录选择学生</span>
              <el-button type="primary" size="small" plain @click="personPickerVisible = true">选择学生</el-button>
              <el-button v-if="personSelectedItems.length" type="text" size="small" @click="clearPersonSelection">清空</el-button>
            </div>
            <div v-if="personSelectedItems.length" class="ps-pick-tags">
              <el-tag
                v-for="item in personSelectedPreview"
                :key="item.id"
                size="mini"
                closable
                disable-transitions
                @close="removePersonSelected(item.id)">
                {{ item.name }}
              </el-tag>
              <span v-if="personSelectedItems.length > 8" class="ps-pick-more">等 {{ personSelectedItems.length }} 人</span>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="bindDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitBindUsers">绑定所选人员</el-button>
        </div>
      </el-dialog>

      <person-scope-multi-picker-dialog
        :visible.sync="personPickerVisible"
        directory-scope="teaching"
        :show-scope-tabs="false"
        :scope-department-id="departmentId"
        title="选择学生"
        :value="personSelectedItems"
        @confirm="onPersonsPicked"
      />

      <el-dialog :title="`套餐明细 - ${quotaDialog.studentName || ''}`" :visible.sync="quotaDialog.visible" width="760px">
        <el-table :data="quotaDialog.rows" v-loading="quotaDialog.loading">
          <el-table-column label="月份" min-width="100" align="center">
            <template slot-scope="scope">{{ formatYearMonth(scope.row.YearMonth || scope.row.yearMonth) }}</template>
          </el-table-column>
          <el-table-column prop="AllocatedMinutes" label="分配分钟" align="center" />
          <el-table-column prop="UsedMinutes" label="已用分钟" align="center" />
          <el-table-column prop="RemainMinutes" label="剩余分钟" align="center" />
          <el-table-column label="到期时间" min-width="140" show-overflow-tooltip align="center">
            <template slot-scope="scope">{{ scope.row.ExpireTime || scope.row.expireTime || '—' }}</template>
          </el-table-column>
          <el-table-column label="状态" align="center" width="100">
            <template slot-scope="scope">
              <el-tag size="small" :type="getQuotaStatusTagType(scope.row)">
                {{ formatQuotaRowStatus(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table>
        <div class="record-page">
          <el-pagination layout="total, prev, pager, next, jumper" :current-page="quotaDialog.page"
            :page-size="quotaDialog.pageSize" :total="quotaDialog.total" @current-change="onQuotaDialogPageChange" />
        </div>
      </el-dialog>
    </section>
  </section>
</template>

<script>
import './styles/comm-page.css'
import CommFilterBar from './components/CommFilterBar.vue'
import DepartmentPane from '../../components/DepartmentPane'
import PersonScopeMultiPickerDialog from '../../components/PersonScopeMultiPickerDialog'
import { getCommRuleListPage, saveCommRule, deleteCommRule, setCommRuleEnabled, exportCommRules, getCommBindingQuotaPage } from '../../api/modules/misc';
import { getSchoolDepartmentTree } from '../../api/modules/department';
import { getCommRuleUserListPage, batchBindCommRuleUsers } from '../../api/modules/system'

const defaultButtons = [
  { name: '查询', Func: 'handleQuery' },
  { name: '导出', Func: 'handleExport' },
  { name: '新增', Func: 'openAdd' },
  { name: '删除选中', Func: 'removeSelected', btnType: 'danger' }
]

export default {
  components: { CommFilterBar, DepartmentPane, PersonScopeMultiPickerDialog },
  data() {
    return {
      searchList: [
        { label: '名称', key: 'ruleName', width: '180px', placeholder: '规则名称' },
        { label: '类型', key: 'pkgType', type: 'select', options: [{ label: '全部', value: '' }, { label: '按月套餐', value: 1 }, { label: '一次性套餐', value: 2 }], width: '140px' }
      ],
      filters: {},
      buttonList: [],
      loading: false,
      page: 1,
      pageSize: 10,
      total: 0,
      departmentId: '',
      rules: [],
      selectionRows: [],
      dialogVisible: false,
      editForm: {},
      deptOptions: [],
      deptCascaderKey: 0,
      ruleUserDialog: { visible: false, ruleId: 0, ruleName: '' },
      bindDialogVisible: false,
      personSelectedItems: [],
      personPickerVisible: false,
      ruleUserLoading: false,
      ruleUserFilters: { studentName: '' },
      ruleUserRows: [],
      ruleUserPage: 1,
      ruleUserPageSize: 10,
      ruleUserTotal: 0,
      quotaDialog: {
        visible: false,
        studentName: '',
        bindingId: null,
        rows: [],
        loading: false,
        page: 1,
        pageSize: 5,
        total: 0
      }
    }
  },
  computed: {
    personSelectedPreview() {
      return (this.personSelectedItems || []).slice(0, 8)
    }
  },
  methods: {
    parseDateTime(value) {
      if (!value) return null
      if (value instanceof Date) return value
      const dt = new Date(String(value).replace(/-/g, '/'))
      return Number.isNaN(dt.getTime()) ? null : dt
    },
    isBindingExpired(row) {
      const expireTime = this.parseDateTime(row && row.ExpireTime)
      if (!expireTime) return false
      return expireTime.getTime() < Date.now()
    },
    formatBindingStatus(row) {
      const st = Number(row && row.Status)
      if (st === 3) return '已解绑'
      if (st === 2) return '已失效'
      if (st === 0) return '未生效'
      if (st !== 1) return '已失效'
      if (this.isBindingExpired(row)) return '已过期'
      return '生效中'
    },
    getBindingStatusTagType(row) {
      const status = this.formatBindingStatus(row)
      if (status === '生效中') return 'success'
      if (status === '已解绑') return 'warning'
      if (status === '未生效') return 'info'
      return 'danger'
    },
    normalizeQuotaListRow(raw) {
      if (!raw || typeof raw !== 'object') return {}
      const n = (v, alt) => (v !== undefined && v !== null ? v : alt)
      const num = (v, alt) => {
        const x = n(v, alt)
        const t = Number(x)
        return Number.isFinite(t) ? t : 0
      }
      return {
        ...raw,
        YearMonth: n(raw.YearMonth, raw.yearMonth),
        ExpireTime: n(raw.ExpireTime, raw.expireTime),
        Status: raw.Status !== undefined && raw.Status !== null ? raw.Status : raw.status,
        AllocatedMinutes: num(raw.AllocatedMinutes, raw.allocatedMinutes),
        UsedMinutes: num(raw.UsedMinutes, raw.usedMinutes),
        RemainMinutes: num(raw.RemainMinutes, raw.remainMinutes)
      }
    },
    formatQuotaRowStatus(row) {
      if (!row || typeof row !== 'object') return '—'
      const s = Number(row.Status != null ? row.Status : row.status)
      if (Number.isNaN(s)) return '—'
      if (s === 0) return '未生效'
      if (s === 4) return '随绑定解绑'
      if (s === 2) return '已用尽'
      if (s === 3) return '已过期'
      const exp = this.parseDateTime(row.ExpireTime != null ? row.ExpireTime : row.expireTime)
      if (s === 1 && exp && exp.getTime() < Date.now()) return '已过期'
      if (s === 1) return '生效中'
      return '已失效'
    },
    getQuotaStatusTagType(row) {
      const status = this.formatQuotaRowStatus(row)
      if (status === '生效中') return 'success'
      if (status === '未生效') return 'info'
      if (status === '已用尽') return 'warning'
      return 'danger'
    },
    formatYearMonth(val) {
      const s = String(val == null ? '' : val).trim()
      if (s.length === 6 && /^\d{6}$/.test(s)) return `${s.slice(0, 4)}-${s.slice(4, 6)}`
      return s || '—'
    },
    getEmptyForm() {
      return { Id: 0, RuleName: '', PkgType: 1, Priority: 10, MonthCount: 1, MonthCallDuration: 100, TotalMinutes: 100, ValidDays: 30, PriceYuan: 0.01, IsEnabled: true, DepartmentId: this.departmentId || null, Remark: '' }
    },
    treeNodeClick(data) {
      this.departmentId = data && data.value ? data.value : ''
      this.page = 1
      this.handleQuery()
    },
    callFunction(item) {
      this.filters = typeof item.search === 'object' ? item.search : {}
      if (typeof this[item.Func] === 'function') {
        this[item.Func]()
      }
    },
    handleSelectionChange(rows) {
      this.selectionRows = rows || []
    },
    /** 表格 row-key，兼容 Id / id */
    rulesTableRowKey(row) {
      if (!row) return ''
      const id = row.Id != null ? row.Id : row.id
      return id != null ? id : ''
    },
    /**
     * 点击行切换勾选（勾选列、操作列内按钮及表单控件不触发）。最后修改：2026-05-12
     */
    onRulesTableRowClick(row, column, event) {
      const table = this.$refs.rulesTable
      if (!table || !row) return
      if (column && column.type === 'selection') return
      const el = event && event.target
      if (el && el.closest && el.closest('.el-button, button, a, input, textarea, select, label, .el-switch, .el-radio, .el-checkbox, .el-input, .el-link')) {
        return
      }
      table.toggleRowSelection(row)
    },
    handleCurrentChange(page) {
      this.page = page
      this.handleQuery()
    },
    formatPriceYuan(fen) {
      const n = Number(fen)
      if (!Number.isFinite(n)) return '0.00'
      return (n / 100).toFixed(2)
    },
    pickPageList(pageData) {
      if (!pageData || typeof pageData !== 'object') return []
      const raw = pageData.data != null ? pageData.data : pageData.Data
      return Array.isArray(raw) ? raw : []
    },
    pickPageTotal(pageData) {
      if (!pageData || typeof pageData !== 'object') return 0
      const n = pageData.dataCount != null ? pageData.dataCount : pageData.DataCount
      const total = Number(n)
      return Number.isFinite(total) ? total : 0
    },
    normalizeRuleRow(raw) {
      if (!raw || typeof raw !== 'object') return raw
      const pick = (a, b) => (raw[a] != null ? raw[a] : raw[b])
      return {
        ...raw,
        Id: pick('Id', 'id'),
        RuleName: pick('RuleName', 'ruleName'),
        PkgType: pick('PkgType', 'pkgType'),
        Priority: pick('Priority', 'priority'),
        IsEnabled: pick('IsEnabled', 'isEnabled'),
        PriceFen: pick('PriceFen', 'priceFen'),
        Remark: pick('Remark', 'remark'),
        MonthCount: pick('MonthCount', 'monthCount'),
        MonthCallDuration: pick('MonthCallDuration', 'monthCallDuration'),
        TotalMinutes: pick('TotalMinutes', 'totalMinutes'),
        ValidDays: pick('ValidDays', 'validDays'),
        DepartmentId: pick('DepartmentId', 'departmentId')
      }
    },
    async handleQuery() {
      this.loading = true
      try {
        const params = {
          page: this.page,
          pageSize: this.pageSize,
          ruleName: this.filters.ruleName || '',
          pkgType: this.filters.pkgType || '',
          departmentId: this.departmentId || ''
        }
        const res = await getCommRuleListPage(params)
        if (res.data.success) {
          const pageData = res.data.response || {}
          let list = this.pickPageList(pageData).map((row) => this.normalizeRuleRow(row))
          let total = this.pickPageTotal(pageData)
          if (total > 0 && list.length === 0 && this.page > 1) {
            this.page = 1
            params.page = 1
            const retry = await getCommRuleListPage(params)
            if (retry.data.success) {
              const again = retry.data.response || {}
              list = this.pickPageList(again).map((row) => this.normalizeRuleRow(row))
              total = this.pickPageTotal(again)
            }
          }
          this.rules = list
          this.total = total
        } else {
          this.rules = []
          this.total = 0
          this.$message.error(res.data.msg || '查询失败')
        }
      } finally {
        this.loading = false
      }
    },
    openAdd() {
      this.editForm = this.getEmptyForm()
      this.dialogVisible = true
    },
    openEdit(row) {
      const form = Object.assign(this.getEmptyForm(), row || {})
      const fen = Number(form.PriceFen != null ? form.PriceFen : form.priceFen)
      form.PriceYuan = Number.isFinite(fen) ? Number((fen / 100).toFixed(2)) : 0
      this.editForm = form
      this.dialogVisible = true
    },
    async saveRule() {
      const payload = Object.assign({}, this.editForm)
      const yuan = Number(payload.PriceYuan)
      if (!Number.isFinite(yuan) || yuan <= 0) {
        this.$message.warning('售价必须大于0')
        return
      }
      payload.PriceFen = Math.round(yuan * 100)
      delete payload.PriceYuan
      const res = await saveCommRule(payload)
      if (res.data.success) {
        this.$message.success(res.data.msg || '保存成功')
        this.dialogVisible = false
        this.handleQuery()
      } else {
        this.$message.error(res.data.msg || '保存失败')
      }
    },
    async removeRule(row) {
      await this.$confirm('确认删除该规则吗？', '提示')
      const res = await deleteCommRule({ id: row.Id })
      if (res.data.success) {
        this.$message.success('删除成功')
        this.handleQuery()
      } else {
        this.$message.error(res.data.msg || '删除失败')
      }
    },
    async removeSelected() {
      if (!this.selectionRows.length) {
        this.$message.warning('请先选择数据')
        return
      }
      await this.$confirm(`确认删除选中的 ${this.selectionRows.length} 条规则吗？`, '提示')
      for (const row of this.selectionRows) {
        await deleteCommRule({ id: row.Id })
      }
      this.$message.success('删除完成')
      this.handleQuery()
    },
    async setEnabled(row, enabled) {
      const actionText = enabled ? '启用' : '停用'
      try {
        await this.$confirm(`确认${actionText}规则“${row.RuleName || row.Id}”吗？`, '提示')
      } catch (e) {
        return
      }
      const res = await setCommRuleEnabled({ id: row.Id, enabled })
      if (res.data.success) {
        this.$message.success('操作成功')
        this.handleQuery()
      } else {
        this.$message.error(res.data.msg || '操作失败')
      }
    },
    async loadBindDepartmentTree() {
      const res = await getSchoolDepartmentTree({ pid: 0, type: 1 })
      this.deptOptions = res.data.success && res.data.response ? [res.data.response] : []
      this.deptCascaderKey += 1
    },
    async openRuleUsers(row) {
      if (!this.departmentId) {
        this.$message.warning('请先在左侧选择学校')
        return
      }
      this.ruleUserDialog = { visible: true, ruleId: row.Id, ruleName: row.RuleName || '' }
      this.bindDialogVisible = false
      this.clearPersonSelection()
      this.ruleUserFilters = { studentName: '' }
      this.ruleUserPage = 1
      this.ruleUserRows = []
      this.ruleUserTotal = 0
      await this.loadRuleUserRows()
    },
    onBindDialogOpen() {
      this.clearPersonSelection()
    },
    onPersonsPicked(people) {
      this.personSelectedItems = (people || []).map((p) => ({
        id: String(p.id),
        name: p.name || String(p.id),
        personType: 'student',
        deptId: p.deptId != null ? String(p.deptId) : '0',
        deptLabel: p.deptLabel || ''
      }))
    },
    clearPersonSelection() {
      this.personSelectedItems = []
    },
    removePersonSelected(id) {
      const key = String(id)
      this.personSelectedItems = (this.personSelectedItems || []).filter((x) => String(x.id) !== key)
    },
    async submitBindUsers() {
      const studentIds = (this.personSelectedItems || [])
        .map((x) => Number(x.id))
        .filter((id) => id > 0)
      if (!this.ruleUserDialog.ruleId) {
        this.$message.warning('规则信息异常，请重新打开')
        return
      }
      if (!studentIds.length) {
        this.$message.warning('请先选择人员')
        return
      }
      const res = await batchBindCommRuleUsers({ RuleId: this.ruleUserDialog.ruleId, StudentIds: studentIds, Source: 'admin' })
      if (res.data.success) {
        this.$message.success(res.data.msg || '绑定成功')
        this.clearPersonSelection()
        this.bindDialogVisible = false
        this.ruleUserPage = 1
        await this.loadRuleUserRows()
      } else {
        this.$message.error(res.data.msg || '绑定失败')
      }
    },
    async loadRuleUserRows() {
      if (!this.ruleUserDialog.ruleId) return
      this.ruleUserLoading = true
      try {
        const res = await getCommRuleUserListPage({
          page: this.ruleUserPage,
          pageSize: this.ruleUserPageSize,
          ruleId: this.ruleUserDialog.ruleId,
          studentName: this.ruleUserFilters.studentName || ''
        })
        if (res.data.success) {
          const pageData = res.data.response || {}
          this.ruleUserRows = pageData.data || []
          this.ruleUserTotal = pageData.dataCount || 0
        } else {
          this.$message.error(res.data.msg || '查询失败')
        }
      } finally {
        this.ruleUserLoading = false
      }
    },
    handleRuleUserPageChange(page) {
      this.ruleUserPage = page
      this.loadRuleUserRows()
    },
    async openQuotaDetail(row) {
      const bindingId = row.Id != null ? row.Id : row.id
      this.quotaDialog = {
        visible: true,
        studentName: row.StudentName || '',
        bindingId,
        rows: [],
        loading: true,
        page: 1,
        pageSize: 5,
        total: 0
      }
      await this.loadQuotaDialogPage()
    },
    onQuotaDialogPageChange(page) {
      this.quotaDialog.page = page
      this.loadQuotaDialogPage()
    },
    /** 分页拉取套餐明细（每页 5 条，按绑定 Id）。最后修改：2026-06-25 */
    async loadQuotaDialogPage() {
      const q = this.quotaDialog
      const bindingId = Number(q.bindingId)
      if (!bindingId) {
        q.loading = false
        return
      }
      q.loading = true
      try {
        const res = await getCommBindingQuotaPage({
          bindingId,
          page: q.page,
          pageSize: q.pageSize
        })
        if (res.data.success) {
          const pageData = res.data.response || res.data.Response || {}
          const rawList = pageData.data || pageData.Data || []
          q.rows = rawList.map((x) => this.normalizeQuotaListRow(x))
          q.total = pageData.dataCount != null ? pageData.dataCount : (pageData.DataCount || 0)
        } else {
          this.$message.error(res.data.msg || '获取套餐明细失败')
        }
      } finally {
        q.loading = false
      }
    },
    async handleExport() {
      const params = {
        ruleName: this.filters.ruleName || '',
        pkgType: this.filters.pkgType || '',
        departmentId: this.departmentId || ''
      }
      const res = await exportCommRules(params)
      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', `话机规则_${new Date().getTime()}.xlsx`)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    }
  },
  mounted() {
    this.buttonList = defaultButtons
  }
}
</script>

<style scoped>
.ps-pick-summary {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  color: #475569;
  font-size: 13px;
}
.ps-pick-tags {
  margin-top: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.ps-pick-more {
  color: #94a3b8;
  font-size: 12px;
  line-height: 24px;
}
.muted-text {
  color: #94a3b8;
}
.all_page_border {
  padding: 12px;
  background: #fff;
}

.dialog-footer {
  text-align: right;
}

.rule-edit-form {
  padding-right: 8px;
}

.rule-edit-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.rule-edit-row__item {
  flex: 1;
  min-width: 0;
  margin-bottom: 12px;
}

.rule-edit-tip {
  margin: -4px 0 14px 96px;
  padding: 6px 10px;
  font-size: 12px;
  line-height: 1.5;
  color: #64748b;
  background: #f8fafc;
  border-radius: 6px;
}

.rule-type-group {
  display: inline-flex;
}

.rule-num {
  width: 100%;
}

.rule-num >>> .el-input__inner {
  text-align: left;
}

.bind-footer {
  margin-top: 12px;
}

.record-page {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.expired-text {
  color: #f56c6c;
  font-weight: 500;
}
</style>
